// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".svg-inline--fa[data-v-5d87146a]{color:#000}.v-item--active .svg-inline--fa[data-v-5d87146a]{color:#0063a6}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
